import React from "react";
import { AccountFormBody } from "tsi-common-react/src/apps/customer-account/AccountFormBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ChangePasswordDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountFormBody {...props} />
    </PageSkeleton>
);
